import homeUrl from "./home-url";
import {selectSectionByPage,getSectionCookie} from "./section-cookie";
import searchFormUrl from "./search";

export default function initializeSections() {
    selectSectionByPage();

    const current_section = getSectionCookie() ?? 'he';
    document.body.classList.add('section-' + current_section);
    document.body.dataset.section = current_section;
    document.querySelector('nav.main-menu')?.classList.add('d-xl-block');


    document.querySelectorAll('nav.section-menu .menu__item').forEach(function (el) {
        if (el.classList.contains('active-' + current_section)) {
            el.classList.add('menu__item--current');
        }
    });

    if(document.querySelector('.breadcrumbs__list')) {
        const firstBreadcrumb = document.querySelector('.breadcrumbs__list li:first-child');
        if(firstBreadcrumb) {
            firstBreadcrumb.querySelector('a').href = document.body.dataset[current_section + '_home_url'] ?? '/';
            firstBreadcrumb.querySelector('a span').textContent = current_section === 'he' ? 'On' : 'Ona';
        }
    }

    homeUrl();
    searchFormUrl();

}